import React, { Component } from 'react';
import Loader from 'halogen/RingLoader';
import { Table } from 'react-bootstrap';
import moment from 'moment';

import firebase from '../helpers/firebase';
import TimeOffFilter from '../class/TimeoffFilter'
import { formatNumber, calculateEarnedPto } from '../helpers/utils';
import { TIMEOFF } from '../helpers/constants';
import { calculateNewBalances } from '../helpers/balanceTableCalculator';

class BalanceTable extends Component {
  state = {
    currentBalances: {},
    newBalances: {},
    balanceDate: '',
  }

  constructor(props) {
    super(props);
    this.updateBalances(this.props, Date.now());
  }

  // eslint-disable-next-line
  componentWillReceiveProps(nextProps) {
    // only update if necessary
    if (
      this.props.editTimeoffId !== nextProps.editTimeoffId ||
      this.props.startDate !== nextProps.startDate ||
      (this.props.endDate && (this.props.endDate !== nextProps.endDate)) ||
      this.props.type !== nextProps.type ||
      this.props.userId !== nextProps.userId ||
      this.props.totalDays !== nextProps.totalDays ||
      this.props.totalDaysNextYear !== nextProps.totalDaysNextYear
    ) {
      this.updateBalances(nextProps, Date.now());
    }
  }

  updateBalances(props, timestamp) {
    const {
      onNextYearBalanceChange, onBalanceChange, editTimeoffId, startDate, endDate, yearOfBalance, type, userId, totalDays, totalDaysNextYear
    } = props || this.props;

    if (!userId) {
      return;
    }

    const timeoffFilter = new TimeOffFilter(yearOfBalance);
    const daysNextYear = totalDaysNextYear || 0;
    const currentYear = moment(yearOfBalance).year() === moment().year();
    let newBalances, currentBalances, balance;

    firebase.database().ref('balances').child(userId).once('value').then(snapshot => {
      balance = snapshot.val();
      currentBalances = balance.current;
      if (currentYear) {
        newBalances = calculateNewBalances(balance.current, moment(), endDate, balance.rules.pto.annualAmount);
      } else {
        newBalances = calculateNewBalances(balance.nextYear, moment(yearOfBalance).startOf('year'), endDate, balance.rules.pto.annualAmount);
      }

      newBalances.wfh.balance = 3;
      newBalances.wfh.used = 0;
      newBalances.wfh.earned = 3;
      newBalances[TIMEOFF.PTO.type].annuallyUsed = 0;
      newBalances[TIMEOFF.PTO.type].expectedAnnualValue = calculateEarnedPto(moment(yearOfBalance).endOf('year'), balance.startDate).earnedPto;

      return firebase.database().ref('timeoffs')
        .orderByChild('userId').equalTo(userId).once('value');
    }).then((snapshots) => {
      snapshots.forEach(timeoffSnapshot => {
        const timeoff = timeoffSnapshot.val();
        if (timeoffSnapshot.key === editTimeoffId) return;

        if (timeoffFilter.isValidTimeoff(timeoff)) {
          if (currentYear) {
            const localDaysNextYear = timeoff.daysNextYear || 0;
            newBalances[timeoff.type].used =
              formatNumber(newBalances[timeoff.type].used + timeoff.days - localDaysNextYear);
            newBalances[timeoff.type].balance =
              formatNumber(newBalances[timeoff.type].balance - timeoff.days + localDaysNextYear);
          } else {
            const localDaysNextYear = timeoff.daysNextYear ? timeoff.daysNextYear : timeoff.days;
            newBalances[timeoff.type].used = formatNumber(newBalances[timeoff.type].used + localDaysNextYear);
            newBalances[timeoff.type].balance = formatNumber(newBalances[timeoff.type].balance - localDaysNextYear);
          }
        }

        if (timeoff.type === TIMEOFF.PTO.type) {
          newBalances[timeoff.type].annuallyUsed += timeoffFilter.validDaysWithinFilterYear(timeoff);
        }

      });

      // requesting timeoff adjustments
      if (type) {
        if (currentYear || moment(startDate).year() === moment(yearOfBalance).year()) {
          newBalances[type].balance = formatNumber(newBalances[type].balance - totalDays + daysNextYear);
          if (type === TIMEOFF.PTO.type) newBalances[type].annuallyUsed = formatNumber(newBalances[type].annuallyUsed + totalDays - daysNextYear);
        } else {
          newBalances[type].balance = formatNumber(newBalances[type].balance - daysNextYear);
          if (type === TIMEOFF.PTO.type) newBalances[type].annuallyUsed = formatNumber(newBalances[type].annuallyUsed + daysNextYear);
        }
      }

      this.setState({
        currentBalances,
        newBalances,
        balanceDate: startDate,
      });
      onBalanceChange && onBalanceChange(newBalances, balance);
      onNextYearBalanceChange && onNextYearBalanceChange(newBalances, balance);
    });
  }

  render() {
    const { newBalances, balanceDate } = this.state;
    const { type, totalDays, totalDaysNextYear, startDate, yearOfBalance } = this.props;
    const yearString = moment(yearOfBalance).format('YYYY');
    const currentYear = moment(yearOfBalance).year() === moment(startDate).year();
    const timeoffConsumeDay = currentYear ? (totalDays - totalDaysNextYear) : totalDaysNextYear;

    if (!balanceDate) {
      return (
        <div className="loader-wrapper" style={{height: '198px'}}>
          <Loader color="#26194b" size="60px" className="loader-small" />
        </div>
      )
    }

    return (
      <Table striped bordered condensed hover>
        <thead>
          <tr>
            <th>Type</th>
            <th>Earned</th>
            <th>Used</th>
            { totalDays ? <th>This Request</th> : null }
            <th>Balance</th>
            <th>{yearString} Used</th>
            <th>{yearString} Expected Total Amount</th>
          </tr>
        </thead>
        <tbody>
          { Object.keys(TIMEOFF).map(key => {
            let timeoff = TIMEOFF[key];
            let newBalancesOfTimeoffType = newBalances[timeoff.type];
            return (
              <tr key={timeoff.type}>
                <td>{timeoff.fullForm}</td>
                <td>
                  {newBalancesOfTimeoffType.earned}
                  {newBalancesOfTimeoffType.carriedOver
                    ? ` (+${newBalancesOfTimeoffType.carriedOver} carried over)`
                    : null
                  }
                  {newBalancesOfTimeoffType.makeupEarned
                    ? ` (+${newBalancesOfTimeoffType.makeupEarned} make-up days)`
                    : null
                  }
                </td>
                <td>{newBalancesOfTimeoffType.used}</td>
                { totalDays
                  ? <td>{timeoff.type === type ? '-' + timeoffConsumeDay : null}</td>
                  : null
                }
                <td>{newBalancesOfTimeoffType.balance}</td>
                <td>{newBalancesOfTimeoffType.annuallyUsed ? newBalancesOfTimeoffType.annuallyUsed : ''}</td>
                <td>
                  { `${formatNumber(newBalancesOfTimeoffType.expectedAnnualValue) +
                    formatNumber(newBalancesOfTimeoffType.carriedOver) +
                    formatNumber(newBalancesOfTimeoffType.makeupEarned)}`
                  }
                  {newBalancesOfTimeoffType.carriedOver
                    ? ` (with ${newBalancesOfTimeoffType.carriedOver} carried over)`
                    : null
                  }
                  {newBalancesOfTimeoffType.makeupEarned
                    ? ` (with ${newBalancesOfTimeoffType.makeupEarned} make-up days)`
                    : null
                  }
                </td>
              </tr>
            );
          }) }
        </tbody>
      </Table>

    );
  }
}

export default BalanceTable



// WEBPACK FOOTER //
// ./src/components/BalanceTable.js